import pluralize from 'pluralize';

import {
  ComponentLinkItemPreview,
  ComponentLinkItemPreviewNarrow,
} from '../shared/component-parts';
import { ViewProps } from './guided-research.constants';
import { COMPONENT_LAYOUT_LIST } from 'global/constants';

const GuidedResearchStaticPreview = (props: ViewProps) => {
  if (!props.stimulusResourceProperties) return null;

  const componentLinkItemProps = {
    primaryText: props.stimulusResourceProperties.resourceName,
    squareImage: props.stimulusResourceProperties.coverImage,
    textBadge: `${props.stimulusResourceProperties.links.length} ${pluralize(
      'link',
      props.stimulusResourceProperties.links.length
    )}`,
  };

  return (
    <>
      {props.properties.layout?.display === COMPONENT_LAYOUT_LIST ? (
        <ComponentLinkItemPreviewNarrow {...componentLinkItemProps} />
      ) : (
        <ComponentLinkItemPreview {...componentLinkItemProps} />
      )}
    </>
  );
};

export default GuidedResearchStaticPreview;
